import { createAsyncThunk } from '@reduxjs/toolkit';

import { asyncPayloadCreator } from 'utils';

import { AccountService } from 'api';

import { ResetPasswordProps } from 'models/api';

export const resetPassword = createAsyncThunk(
	'forgotPassword/resetPassword',
	(credentials: ResetPasswordProps, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, AccountService.resetPassword),
);
